import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";

import { CtEduTemplateList } from "containers";
import { EduTemplateMenu, AdminPageTitle, AdminPageTemplate } from "components";

class CtAdminEduTemplate extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth } = this.props;

    return (
      <AdminPageTemplate className="table">
        <AdminPageTitle type="table" title={defineMessages(formatMessage({ id: "MyPageMenu_11", defaultMessage: "교육 템플릿" }))}>
          {isAuth === 2 && <EduTemplateMenu />}
        </AdminPageTitle>
        <CtEduTemplateList />
      </AdminPageTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.user.get("isAuth"),
});

export default connect(mapStateToProps, null)(injectIntl(CtAdminEduTemplate));



// WEBPACK FOOTER //
// ./src/script/containers/admin/eduTemplate/CtAdminEduTemplate.js